import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-game-title',
  templateUrl: './game-title.component.html',
  styleUrls: ['./game-title.component.scss'],
})
export class GameTitleComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) wordmarkUrl!: string;
  @Input() isWordmark?: boolean = false;

  get titleStyles(): [string, string][] {
    const key = 'game-title';
    return [
      ['type', key],
      ['text-color', key],
      ['text-shadow', key],
      ['text-stroke', key],
    ];
  }
}
